import React from 'react';

import { useTranslation } from '@lt/localization';
import type {
  TransitionInfo,
  TransitionTimeInfo,
} from '@lt/api/dist/methods/packages/types';
import FlightTransferInfo from '../FlightTransferInfo';
import styles from './FlightTransferHint.module.css';

interface IFlightTransferHint {
  transition?: TransitionInfo | null;
  transition_time?: TransitionTimeInfo | null;
}

const FlightTransferHint = ({
  transition = null,
  transition_time = null,
}: IFlightTransferHint) => {
  const { t } = useTranslation();

  return (
    <div className={styles.routeHint}>
      <p className={styles.bottomMarginP}>
        <strong>
          {/* TODO: обработать 2 пересадки, когда будут данные */}
          <span className={styles.textRounded}>1</span>
          <span>{` ${t('checkout.flight.transfer.text')}:`}</span>
        </strong>
      </p>
      <FlightTransferInfo
        transition={transition}
        transitionTime={transition_time}
      />
    </div>
  );
};

export default FlightTransferHint;
